/**
 * Equipment Overview — Frontend ローカル Contract
 *
 * BE 側 `dresscode-backend/v2/src/ga-force/api/equipment-overview/usecase/equipment-overview.api-contract.ts`
 * と同じ Zod 構造を再現。BE が `@standandforce/api-contract` に publish された後、
 * client.ts でローカル import を置き換える想定。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const EquipmentStatusValueSchema = z.enum(['AVAILABLE', 'ASSIGNED', 'PLACED', 'UNDER_REPAIR', 'DECOMMISSIONED']);
const EquipmentCategoryValueSchema = z.enum(['OFFICE_FURNITURE', 'TOOLS_MEASURING_EQUIPMENT', 'RESEARCH_LABORATORY_EQUIPMENT', 'EXHIBITION_DEMO_EQUIPMENT', 'PERIPHERAL_DEVICES', 'CONFERENCE_EQUIPMENT', 'CONSUMABLES', 'PERSONAL_OFFICE_EQUIPMENT', 'OTHER']);
const EquipmentControlTypeValueSchema = z.enum(['INVENTORY_MANAGEMENT', 'DISTRIBUTION_LOG_MANAGEMENT', 'UNMANAGED']);
const EquipmentOverviewRecentItemSchema = z.object({
  equipmentId: z.string(),
  equipmentName: z.string(),
  equipmentStatus: EquipmentStatusValueSchema,
  category: EquipmentCategoryValueSchema,
  occurredAt: z.string()
});
const EquipmentOverviewCountSchema = z.object({
  total: z.number(),
  available: z.number(),
  inUse: z.number(),
  repairOrDisposal: z.number(),
  categoryCount: z.number(),
  controlTypeCount: z.number(),
  byStatus: z.array(z.object({
    status: EquipmentStatusValueSchema,
    count: z.number()
  })),
  byCategory: z.array(z.object({
    category: EquipmentCategoryValueSchema,
    count: z.number()
  })),
  byCategoryAvailable: z.array(z.object({
    category: EquipmentCategoryValueSchema,
    count: z.number()
  })),
  byControlType: z.array(z.object({
    controlType: EquipmentControlTypeValueSchema,
    count: z.number()
  })),
  byPlace: z.array(z.object({
    placeId: z.string(),
    placeName: z.string(),
    count: z.number()
  })),
  monthly: z.array(z.object({
    month: z.string(),
    cumulativeCount: z.number(),
    addedCount: z.number()
  })),
  recent: z.array(EquipmentOverviewRecentItemSchema)
});
export const equipmentOverviewContract = oc.router({
  count: oc.route({
    method: 'GET',
    path: '/v2/equipment-overview/count'
  }).output(EquipmentOverviewCountSchema)
});
export type EquipmentStatusValue = z.infer<typeof EquipmentStatusValueSchema>;
export type EquipmentCategoryValue = z.infer<typeof EquipmentCategoryValueSchema>;
export type EquipmentOverviewCount = z.infer<typeof EquipmentOverviewCountSchema>;
export type EquipmentOverviewRecentItem = z.infer<typeof EquipmentOverviewRecentItemSchema>;